import { getNumberFromCookie, setCookies, setExpiringCookieOrWebStorage, getCookieOrWebStorage } from '../global/_cookies';

import { isInternational } from '../global/_checkForInternational';

import { roundUp } from '../global/_roundUp';

import { intlToggle } from './_intlToggle';
import Cookies from 'js-cookie';

const updateHeaderShoppingBagCounts = (caller) => {
	var cartNumber = getNumberFromCookie('301_CVMINICART', 'items'),
		cartAmountUSD = getNumberFromCookie('301_CVMINICART', 'amount');

	if (isInternational()) {
		$('#myDillardsBagCount, .mobileBagCount').html(cartNumber);
		$('#myDillardsBagPrice').text(quickConvert(cartAmountUSD)).data('converted', true);
	} else {
		$('#myDillardsBagCount, .mobileBagCount').html(cartNumber);
		$('#myDillardsBagPrice').text('$' + cartAmountUSD);
	}
};

var quickConvert = function (number) {
	return '<span class="price-number no-left-margin">' + number + '</span>';		
};

var startIntl = function () {
	var country = Cookies.get('zCountry') !== undefined && Cookies.get('zCountry').trim().length > 0 ? Cookies.get('zCountry') : 'US';	
	if (country == 'US') {
		$('#topbar-wrapper #main-nav ul li.show-when-international').hide();
	} else {
		intlToggle('', country);
		var $catLink = $('.category-nav-facet ul li a, .landing-brand-facet-wrapper ul li a');
		$('#category-breadcrumbs ul li a, #main-nav ul li a, .category-list li a, .mobile-menu ul a').each(function () {
			addIntlParam(this);
		});
		$('#utility-nav')
			.find('a')
			.each(function () {
				addIntlParam(this);
			});
		$('.contentRecommendationWidget')
			.find('[href]')
			.each(function () {
				addIntlParam(this);
			});
		$('.sitemap-category')
			.find('[href]')
			.each(function () {
				addIntlParam(this);
			});
		$('#product-results')
			.find('[href]')
			.each(function () {
				var $this = $(this),
					thisHREF = $this.attr('href');
				if (
					thisHREF.indexOf('/p/') == -1 &&
					thisHREF.indexOf('/product/') == -1 &&
					thisHREF.indexOf('javascript') == -1 &&
					thisHREF.indexOf('javaScript') == -1
				)
					addIntlParam(this);
			});
		if ($catLink.length > 0) {
			$('.category-nav-facet ul li a, .landing-brand-facet-wrapper ul li a').each(function () {
				addIntlParam(this);
			});
		}		
	}
	$('.barItems').show();	
	
	// $('#OrderItemAdd_qv .color-select, .size-select-group').on('change', function(){runZonosCurrenctConvert();})
	// runZonosCurrenctConvert();
	if (document.getElementById('layoutCart') === null) {
		runZonosCurrenctConvert();
	} else {
		if (document.getElementById('layoutCart') !== null && document.querySelector('.modal-quickview') !== null) {
			runZonosCurrenctConvert();
		}
	}
};

const runZonosCurrenctConvert = () => {
	try{
	  if(typeof zonos === 'object') {
	    zonos.displayCurrency();
	  }else {
	    var zonosInterval = setInterval(function () {
	      if (typeof zonos === 'object') {
	        zonos.displayCurrency();
	        clearInterval(zonosInterval);
	      }
	    }, 250);

	    setTimeout(function () {
	      clearInterval(zonosInterval);
	    }, 5000);
	  }
	} catch (e) {
	  console.log(e);
	}
}

const hideChatCheckoutIntl = () => {
	if ($("#layoutCheckout").length > 0 && Cookies.get('zCountry') != 'US') {
		window.hideChat=true
	}
}

const retrieveIntlCacheCallVariable = () => {
	var country = Cookies.get('zCountry') !== undefined && Cookies.get('zCountry').trim().length > 0 ? Cookies.get('zCountry') : 'US';	
	if (country != 'US') {
		var intlCacheCallVariable = getCookieOrWebStorage('intlCacheCallVariable');
		if (!intlCacheCallVariable) {
			const future30MinDate = new Date(Date.now() + 30 * 60 * 1000);

			$.ajax({
				url: '/webapp/wcs/stores/servlet/NonCacheESpot?emsName=ES_Header_Promo&maxNumDisp=1&storeId=301&catalogId=301&langId=-1',
				cache: true,
				type: 'GET',
				dataType: 'json',
				success: function (json) {
					setExpiringCookieOrWebStorage('sessionStorage', 'intlCacheCallVariable', json.JSON.intlCacheCallVariable, future30MinDate);
				},
				error: function (jqXHR, textStatus, errorThrown) {
					const cookieDomain = document.domain != 'localhost' ? '.' + document.domain : 'localhost';
					Cookies.set('intlCacheCallVariable', '999', {
						path: '/',
						expires: future30MinDate,
						domain: cookieDomain,
					});
				},
			});
		}
	}
};

const addIntlParam = (elem) => {
	if(elem.href && elem.href.length > 0){
		if (!window.location.origin) window.location.origin = window.location.protocol + '//' + window.location.hostname;
		if (!elem.origin) elem.origin = elem.protocol + '//' + elem.hostname;
		if (window.location.origin.indexOf(elem.origin) == -1) return;
		var catlinktext = $(elem).attr('href');
		var catLinkHash = '';
		if (catlinktext.indexOf('#') > 0) {
			catLinkHash = '#' + catlinktext.split('#')[1];
			catlinktext = catlinktext.split('#')[0];
		}
		if (catlinktext.indexOf('dil_shipinternational:Y') < 1) {
			if (catlinktext.indexOf('?') > -1) {
				catlinktext = catlinktext + '&facet=dil_shipinternational:Y';
			} else {
				catlinktext = catlinktext + '?facet=dil_shipinternational:Y';
			}
		}
		$(elem).attr('href', catlinktext + catLinkHash);
	}
};

export { updateHeaderShoppingBagCounts, startIntl, quickConvert, retrieveIntlCacheCallVariable, addIntlParam, hideChatCheckoutIntl };
